var map = {
	"./chat_selected.svg": "9af5",
	"./chat_unselected.svg": "033d",
	"./home_selected.svg": "be1d",
	"./home_unselected.svg": "ca2a",
	"./needs_selected.svg": "c0c4",
	"./needs_unselected.svg": "b8fc",
	"./notifications_selected.svg": "5f26",
	"./notifications_unselected.svg": "c4ab",
	"./shops_selected.svg": "14fc",
	"./shops_unselected.svg": "c4a3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4178";